import { Button } from '@bambi/component-library/src/components/Button/Button';

import { useAppDispatch } from 'src/app/store/hooks';

import { adminActions } from '../admin.slice';

export function MomentmSettingsRouteActions() {
  const dispatch = useAppDispatch();

  const handleAddMomentmSettings = () => {
    dispatch(adminActions.setShowMomentmSettingsModal(true));
    dispatch(adminActions.setEditingMomentmSettingsId(null));
  };

  return (
    <Button variant="primary" onClick={handleAddMomentmSettings}>
      Add Momentm Settings
    </Button>
  );
}
